module.exports = __webpack_public_path__ + "static/img/down_btn9.3752e68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/down_btn9.png
// module id = 599g
// module chunks = 4